module.exports = __webpack_public_path__ + "img/background_original.9e10325a.png";